import React, {Component} from 'react';
import {get} from "../../../api";
import Label from "../../auth/components/Label";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

class Leaderboard extends Component {
    state = {
        leaderboard: [],
        me: {
            earnings: 0
        },
        rank: 0,
    }

    componentDidMount() {
        this.loadLeaderboard()
    }


    loadLeaderboard = () => {
        this.setState({loading: true})
        get('/analytics/product_leaderboard')
            .then((data) => {
                this.setState(data)
                this.setState({loading: false})
            }).catch((e) => {
            this.setState({loading: false})
        })
    }


    render() {
        if (this.state.rank === 0) return null;
        if (!this.state.leaderboard) return null;
        const myEarnings = this.state.me.earnings;
        let needs = 0
        if (this.state.rank > 1) {
            const found = this.state.leaderboard.find(({rank}) => rank === this.state.rank - 1);
            if (found) {
                needs = found.earnings - myEarnings;
            }
        }
        return (
            <div className="card">
                <div className="card-body">
                    <Label><FormattedMessage id={"Product rank"}/></Label>
                    <div className={"display-4"}>{this.state.rank}</div>
                    {
                        needs > 0 ? <span className={"text-danger"}>
                                {needs} behind #{this.state.rank - 1}</span> : null
                    }
                </div>
                <ul className="list-group list-group-flush">
                    {
                        this.state.leaderboard.map((item) => {
                            const val = myEarnings - item.earnings
                            let cmp = null;
                            if (val > 0) {
                                cmp = <span className={"text-success"}>{val}</span>
                            } else if (val < 0) {
                                cmp = <span className={"text-danger"}>{val}</span>
                            }
                            const isSelf = String(item.affiliate_id) === String(this.props.affiliate_id)
                            return <li className="list-group-item" key={item.affiliate_id}>
                                <div className="d-flex align-items-center justify-content-between">
                                    <div>
                                        <strong className={"mr-2 font-bold"}>#{item.rank}</strong>
                                        <span className={isSelf ? 'text-info' : ''}>{isSelf ?
                                            <FormattedMessage id={"You"}/> : item.name}</span>
                                    </div>
                                    {cmp}
                                </div>
                            </li>
                        })
                    }
                </ul>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        affiliate_id: state.settings.affiliate_id
    }
}

export default connect(mapStateToProps)(Leaderboard);
